import { Box } from '@/shared/ui';

import { Z_INDEX } from '@/config/z-index';
import PremiumFeatureMessage from '@/features/_shared/UpgradeToPremium/PremiumFeatureMessage';
import UpgradeToPremiumButton from '@/features/_shared/UpgradeToPremium/UpgradeToPremiumButton';

const PremiumWidgetDenied = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        '&:before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundImage: "url('/img/preview/history-chart.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(5px)',
          transform: 'scale(1.05)',
          zIndex: Z_INDEX.base
        }
      }}
    >
      <Box
        sx={{
          position: 'relative',
          zIndex: Z_INDEX.raised,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center',
          alignItems: 'center',
          gap: '8px',
          height: '542px'
        }}
      >
        <PremiumFeatureMessage />
        <UpgradeToPremiumButton
          sx={{
            mt: '8px'
          }}
          type='upgrade'
        />
      </Box>
    </Box>
  );
};

export default PremiumWidgetDenied;
